export default __webpack_public_path__ + "static/media/total_services.265ede0f.svg";